import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import "../styles/products.css";
import { WHATSAPP_NUMBER, API_BASE } from "../config";

function ProductCard({ _id, id, name, category, description, image, hsnCode }) {
  const navigate = useNavigate();
  const productId = _id || id;
  const message = hsnCode
    ? `Hi, I'm interested in ${name} (HSN: ${hsnCode}). Can you share more details?`
    : `Hi, I'm interested in ${name}. Can you share more details?`;
  const link = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

  const handleCardClick = () => {
    navigate(`/products/${productId}`);
  };

  const handleWhatsAppClick = (e) => {
    e.stopPropagation(); // prevent card click navigation
    try {
      fetch(`${API_BASE}/analytics/inquiry`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ product: name }),
      }).catch(() => {});
    } catch (err) {
      console.error("Inquiry log failed:", err);
    }
  };

  return (
    <div className="product-card" onClick={handleCardClick} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === "Enter") handleCardClick(); }}>
      <div
        className="product-image"
        style={{ backgroundImage: image ? `url(${image})` : undefined }}
        role={image ? "img" : undefined}
        aria-label={image ? name : undefined}
      />
      <div className="product-body">
        <span className="product-category">{category}</span>
        <h3>{name}</h3>
        <p className="product-desc">{description}</p>

        <div className="product-card-actions">
          <Link
            to={`/products/${productId}`}
            className="btn-primary btn-view-details"
            onClick={(e) => e.stopPropagation()}
          >
            View Details
          </Link>
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-whatsapp-round"
            onClick={handleWhatsAppClick}
            title="Enquire on WhatsApp"
            aria-label={`Enquire on WhatsApp for ${name}`}
          >
            <FaWhatsapp size={20} />
          </a>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
